import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormGroup from '../../../components/global/FormGroup';
import CustomControl from '../../../components/global/CustomControl';
import Alert from '../../../components/global/Alert';
import Button from '../../../components/global/Button';
import { getFormikTouchedErrors } from '../../../util/formik';
import { sanitizePromoCode } from '../../../components/global/PromoCodeInput/helpers';
import DismissButton from '../../../components/global/DismissButton';

const propTypes = {
  className: PropTypes.string,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const RegisterAppSumoDetailsForm = ({
  className,
  handleSubmit,
  values,
  errors,
  touched,
  loading,
  handleChange,
  handleBlur,
}) => {
  const classes = classNames({
    'view-register-form': true,
    [className]: !!className,
  });
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  return (
    <form className={classes} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-lg-6 col-12">
          <FormGroup
            id="first_name"
            name="first_name"
            label="First name"
            labelSrOnly
            placeholder="First name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.first_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="last_name"
            name="last_name"
            label="Last name"
            labelSrOnly
            placeholder="Last name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.last_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="organization_name"
            name="organization_name"
            label="Company name"
            labelSrOnly
            placeholder="Company name"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.organization_name}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="email_address"
            name="email_address"
            label="Email address"
            labelSrOnly
            placeholder="Email address"
            required
            type="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email_address}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="password"
            name="password"
            label="Password"
            labelSrOnly
            placeholder="Password"
            required
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
        </div>
        <div className="col-lg-6 col-12">
          <FormGroup
            id="password_confirm"
            name="password_confirm"
            label="Confirm password"
            labelSrOnly
            placeholder="Confirm password"
            required
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password_confirm}
          />
        </div>

        <div className="col-12">
          <FormGroup
            id="app_sumo_code"
            name="app_sumo_code"
            label="Redemption Code"
            labelSrOnly
            placeholder="Your AppSumo redemption code"
            type="text"
            className="view-register-promo-box"
            required
            onChange={event => {
              const { value } = event.target;

              handleChange({
                target: {
                  name: 'app_sumo_code',
                  value: sanitizePromoCode(value),
                },
              });
            }}
            onBlur={handleBlur}
            value={values.app_sumo_code}
          />

          {errors.promo_code && (
            <DismissButton
              className="view-register-promo-box-dismiss"
              onClick={() => {
                handleChange({
                  target: {
                    name: 'promo_code',
                    value: '',
                  },
                });
              }}
            />
          )}
        </div>

        <div className="col-12">
          <CustomControl
            id="terms_checked"
            type="checkbox"
            name="terms_checked"
            label={
              <span>
                I agree to the{' '}
                <a href="/terms" target="_blank" rel="nofollow">
                  Terms of Service
                </a>
              </span>
            }
            required
            onChange={handleChange}
            checked={values.terms_checked}
            className="mb-4"
          />
        </div>
      </div>

      {errorList?.length > 0 && (
        <Alert type="danger" className="mb-4">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      <Button
        type="submit"
        btnBlock
        btnSize="lg"
        disabled={loading}
        loading={loading}
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {loading ? 'Processing...' : 'Register'}
      </Button>
    </form>
  );
};

RegisterAppSumoDetailsForm.propTypes = propTypes;

export default RegisterAppSumoDetailsForm;
